(function ($) {
  $(() => {
    const dropdownToggle = $(".js-toggle-card-park-buildings");
    const arrowUp = $(".js-card-park-arrow-up");

    if (!dropdownToggle.length && !arrowUp.length) {
      return;
    }

    dropdownToggle.on("click", function (e) {
      e.preventDefault();
      $(this).closest(".card-park").toggleClass("open");
      $(this)
        .closest(".card-park")
        .find(".js-card-park-buildings")
        .toggleClass("hidden");
    });

    arrowUp.on("click", function (e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, 450);
    });
  });
})(jQuery);
